import { useTranslation } from 'react-i18next'
import {
  isRouteErrorResponse,
  useLoaderData,
  useRouteError
} from 'react-router'
import { formatDate, type PrintLoaderData } from './shared'
import * as S from './styles'

export function Page() {
  const { auditData } = useLoaderData() as PrintLoaderData

  return (
    <html lang='en'>
      <head>
        <meta charSet='UTF-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
        <title>QPR Report Printout</title>
        <style>{S.GlobalStyles}</style>
      </head>
      <S.PrintContainer>
        <S.MainTable>
          <tr>
            <S.SpacerCell>&nbsp;</S.SpacerCell>
          </tr>
          <tr>
            <S.MainContentCell>
              <S.ControlsSection className='noPrint'>
                <S.PrintButton
                  type='button'
                  value='Print'
                  onClick={() => {
                    window.print()
                  }}
                />
                <S.PrintButton
                  type='button'
                  value='Close'
                  onClick={() => window.close()}
                />
              </S.ControlsSection>
              <S.PrintDiv id='printDiv'>
                <div>
                  <S.ContentTable className='content-table'>
                    <tr>
                      <S.LogoCell align='left'>
                        <S.ScaniaLogo
                          className='footer-logo-dark'
                          src='/assets/footer_logo_dark.png'
                          alt='Scania Logo'
                        />
                      </S.LogoCell>
                      <td align='right'>
                        <span className='LabelHeader'>
                          {`Notes - Scania Dealer Operating Standard  ${auditData.dosVersion}`}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <S.HrSeparator className='hr-separator' />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <S.InfoTable className='info-table'>
                          <tr>
                            <td align='right' width='100px'>
                              <span className='mini'>Dealer Name:</span>
                            </td>
                            <S.InfoValueCell align='left' width='175px'>
                              <span className='mini'>
                                {auditData.dealerName || '\u00A0'}
                              </span>
                            </S.InfoValueCell>
                            <S.InfoSpacerCell width='50px'></S.InfoSpacerCell>
                            <td align='right' width='100px'>
                              <span className='mini'>Audit Date:</span>
                            </td>
                            <S.InfoValueCell align='left' width='175px'>
                              <span className='mini'>
                                {formatDate(auditData.auditDate) || '\u00A0'}
                              </span>
                            </S.InfoValueCell>
                          </tr>
                          <tr>
                            <td align='right' width='100px'>
                              <span className='mini'>Dealer ID:</span>
                            </td>
                            <S.InfoValueCell align='left' width='175px'>
                              <span className='mini'>
                                {auditData.dealerId || '\u00A0'}
                              </span>
                            </S.InfoValueCell>
                            <S.InfoSpacerCell width='50px'></S.InfoSpacerCell>
                            <td align='right' width='100px'>
                              <span className='mini'>City:</span>
                            </td>
                            <S.InfoValueCell align='left' width='175px'>
                              <span className='mini'>
                                {auditData.city || '\u00A0'}
                              </span>
                            </S.InfoValueCell>
                          </tr>
                        </S.InfoTable>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={2} width='600px'>
                        <S.ActionPlansTable cellPadding={4} cellSpacing={0}>
                          <tbody>
                            <S.ActionPlanRowHeader>
                              <S.ActionPlanHeaderCell
                                align='left'
                                style={{
                                  width: '50px'
                                }}
                              >
                                {'Audit Point #'}
                              </S.ActionPlanHeaderCell>
                              <S.ActionPlanHeaderCell
                                align='left'
                                style={{ width: '150px' }}
                              >
                                {'Notes'}
                              </S.ActionPlanHeaderCell>
                            </S.ActionPlanRowHeader>
                            {auditData.pledges.map((pledge, pledgeIndex) =>
                              pledge.auditPoints.map((auditPoint, apIndex) => {
                                if (!auditPoint.note) return null
                                return (
                                  <S.ActionPlanRow
                                    key={`${pledgeIndex}-${apIndex}`}
                                  >
                                    <S.ActionPlanCell align='left'>
                                      {auditPoint.auditPointNo}
                                    </S.ActionPlanCell>
                                    <S.ActionPlanCell
                                      align='left'
                                      style={{ width: '150px' }}
                                    >
                                      {auditPoint.note}
                                    </S.ActionPlanCell>
                                  </S.ActionPlanRow>
                                )
                              })
                            )}
                          </tbody>
                        </S.ActionPlansTable>
                      </td>
                    </tr>
                  </S.ContentTable>
                </div>
              </S.PrintDiv>
              <br />
            </S.MainContentCell>
          </tr>
        </S.MainTable>
      </S.PrintContainer>
    </html>
  )
}

export function ErrorBoundary() {
  const error = useRouteError()
  const { t } = useTranslation('common')

  if (isRouteErrorResponse(error)) {
    return (
      <html lang='en'>
        <head>
          <meta charSet='UTF-8' />
          <meta
            name='viewport'
            content='width=device-width, initial-scale=1.0'
          />
          <title>Error</title>
        </head>
        <body>
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h1>{t('error')}</h1>
            <p>{error.data?.message || 'Something went wrong'}</p>
          </div>
        </body>
      </html>
    )
  }

  return (
    <html lang='en'>
      <head>
        <meta charSet='UTF-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
        <title>Error</title>
      </head>
      <body>
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>{t('error')}</h1>
          <p>{t('something-went-wrong')}</p>
        </div>
      </body>
    </html>
  )
}
